import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  isLoggedIn: boolean;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {

    this.isLoggedIn = this.authService.isLoggedIn();

    this.authService.listenerIsLoggedIn().subscribe(value => {

      this.isLoggedIn = value;
    });
  }

}
